import { Badge, Box, Tooltip } from '@chakra-ui/react'
import { OfferStatusEnum } from 'BrokerTsLib/src/enums/offerStatusEnum'

export const StatusBadge = ({ status, tooltip }: { status: OfferStatusEnum, tooltip?: string }) => {
  let colorScheme
  let text

  switch (status) {
    case OfferStatusEnum.Error:
      colorScheme = 'red'
      text = 'Chyba'
      break
    case OfferStatusEnum.Selected:
      colorScheme = 'green'
      text = 'Vybraná'
      break
    case OfferStatusEnum.Valid:
      text = ''
      break
  }

  if (!text)
    return null

  const children = (
    <Badge sx={{ h: 4, py: 0, fontSize: 'xs' }} colorScheme={colorScheme}>
      {text}
    </Badge>)

  return (
    <>
      {!!tooltip &&
        <Tooltip hasArrow placement="top" label={<Box dangerouslySetInnerHTML={{ __html: tooltip }}></Box>}>
          {children}
        </Tooltip>
      }

      {!tooltip && children}
    </>
  )
}
